export default __webpack_public_path__ + "static/media/flurry_icon_only.6fdabb9e.png";